import { useEffect } from "react";
import Header from "@/components/shared/Header";
import HeroSection from "./heritage/HeroSection";
import StorySection from "./heritage/StorySection";
import CategoriesSection from "./heritage/CategoriesSection";
import PicksSection from "./heritage/PicksSection";
import VisitSection from "./heritage/VisitSection";
import HeritageFooter from "./heritage/HeritageFooter";
import { useTheme } from "@/contexts/ThemeContext";
import { usePublicAbout } from "@/hooks/usePublicAbout";

export default function HeritageHome() {
  const { isDark, toggleTheme } = useTheme();
  const { about } = usePublicAbout();

  // Heritage template prefers dark mode only on first visit (don't override user preference)
  useEffect(() => {
    const saved = localStorage.getItem("blazebite_theme");
    if (!saved && !isDark) toggleTheme();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <HeroSection onScrollDown={() => scrollTo("story-section")} />
      <StorySection about={about} />
      <CategoriesSection />
      <PicksSection />
      <VisitSection about={about} />
      <HeritageFooter about={about} />
    </div>
  );
}
